import { AppliedFiltersState } from "..";
import { DashboardStorage, FiltersRegistry, RootCauseState } from "../types";

// Only local storage mange logic

// STORAGE KEY
export const FILTERS_STORAGE_KEY = "filters_registry";
export const FILTERS_DASHBOARD_STORAGE_KEY = "filters_dashboard";
export const FILTERS_APPLIED_STORAGE_KEY = "filters_applied";
export const ROOT_CAUSE_STORAGE_KEY = "root_cause";

// LOCAL STORAGE
export const loadFromStorage = (): FiltersRegistry | null => {
	try {
		const raw = localStorage.getItem(FILTERS_STORAGE_KEY);
		if (!raw) return null;
		return JSON.parse(raw);
	} catch {
		return null;
	}
};

export const saveToStorage = (registry: FiltersRegistry) => {
	try {
		localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(registry));
	} catch {
		// silent fail
	}
};

export const loadDashboardFromStorage = (): DashboardStorage | null => {
	try {
		const raw = localStorage.getItem(FILTERS_DASHBOARD_STORAGE_KEY);

		if (!raw) return null;

		return JSON.parse(raw);
	} catch {
		return null;
	}
};

export const saveDashboardToStorage = (dashboard: DashboardStorage) => {
	try {
		localStorage.setItem(FILTERS_DASHBOARD_STORAGE_KEY, JSON.stringify(dashboard));
	} catch {
		// fail silently
	}
};

export const saveAppliedFiltersToStorage = (state: AppliedFiltersState) => {
	try {
		localStorage.setItem(FILTERS_APPLIED_STORAGE_KEY, JSON.stringify(state));
	} catch {
		// silent fail
	}
};

export const loadAppliedFiltersFromStorage = (): AppliedFiltersState | null => {
	try {
		const raw = localStorage.getItem(FILTERS_APPLIED_STORAGE_KEY);

		if (!raw) return null;

		const parsed = JSON.parse(raw);

		if (!parsed?.payload) return null;

		return parsed;
	} catch {
		return null;
	}
};

// Root cause workspace storage
export const saveRootCauseToStorage = (state: RootCauseState) => {
	try {
		localStorage.setItem(ROOT_CAUSE_STORAGE_KEY, JSON.stringify(state));
	} catch {
		//
	}
};

export const loadRootCauseFromStorage = (): RootCauseState | null => {
	try {
		const raw = localStorage.getItem(ROOT_CAUSE_STORAGE_KEY);

		if (!raw) return null;

		return JSON.parse(raw);
	} catch {
		return null;
	}
};

export const clearFiltersStorage = () => {
	try {
		localStorage.removeItem(FILTERS_STORAGE_KEY);
		localStorage.removeItem(FILTERS_DASHBOARD_STORAGE_KEY);
		localStorage.removeItem(FILTERS_APPLIED_STORAGE_KEY);
		localStorage.removeItem(ROOT_CAUSE_STORAGE_KEY);
	} catch {
		// silent fail
	}
};
